import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
 import { ConfigService } from '../../config.service';
import { AESService } from '../../encryption/aes.service';

@Injectable()
export class ListAttributesService {

  constructor(public http: HttpClient, public config: ConfigService,private Cryptography : AESService) {
   
  }
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.Cryptography.getItem('accesstoken',true) })
  };
  listAttr(): Observable<any> {
    return this.http.get(this.config.baseURL + '/attribute/listAttribute', this.httpOptions)
      .map((res) => { return res }

      );
  }
  DeleteAttr(user: any): Observable<any> {
    return this.http.delete<any>(this.config.baseURL + `/attribute/deleteAttribute?id=${user}` , this.httpOptions)
      .map((res) => { return res }

      );
  }
  UpdateAttr(user: any): Observable<any> {
    return this.http.put<any>(this.config.baseURL + '/attribute/editAttribute', user, this.httpOptions)
      .map((res) => { return res }

      );
  }
}
